import { POWER_SOURCES } from "../../OrganizationQuestionnaire/helpers";
import { t } from "i18next";
import { sortAlphabeticallyByAttribute } from "../../../utils";

export const mapScopeOneFactorsData = (data) => {
  return data
    .map(el => {
      return {
        consumptionType: el.consumptionType?.name ?? "",
        measurementUnit: el.measure?.name !== "KWh" ?
          el.measure?.name?.toLowerCase() : el.measure?.name ?? "",
        conversionFactor: el.conversionFactor ?? ""
      };
    })
    .sort((a, b) => sortAlphabeticallyByAttribute(a, b, "consumptionType"));
};

export const mapScopeTwoFactorsData = (data) => {
  return data
    .map(el => {
      return {
        country: el.country?.name ?? "",
        electricityType: POWER_SOURCES[el.electricityType] ?? el.electricityType,
        conversionFactor: el.conversionFactor ?? ""
      };
    })
    .sort((a, b) => sortAlphabeticallyByAttribute(a, b, "country"));
};

export const getCategoryLabel = (key) => {
  return `${t("conversionFactors.categories.category")} ${t(`conversionFactors.categories.${key}`)}`;
};

export const categoriesGroups = Object.freeze({
  "CATEGORY_ONE_AND_TWO": "categoryOneAndTwo",
  "CATEGORY_THREE": "categoryThree",
  "CATEGORY_FOUR_AND_NINE": "categoryFourAndNine",
  "CATEGORY_FIVE_AND_TWELVE": "categoryFiveAndTwelve",
  "CATEGORY_SIX_AND_SEVEN": "categorySixAndSeven",
  "CATEGORY_ELEVEN": "categoryEleven"
});

export const scopeThreeCategories = [
  {
    group: categoriesGroups.CATEGORY_ONE_AND_TWO,
    value: "categoryOne"
  },
  {
    group: categoriesGroups.CATEGORY_ONE_AND_TWO,
    value: "categoryTwo"
  },
  {
    group: categoriesGroups.CATEGORY_THREE,
    value: "categoryThree"
  },
  {
    group: categoriesGroups.CATEGORY_FOUR_AND_NINE,
    value: "categoryFour"
  },
  {
    group: categoriesGroups.CATEGORY_FIVE_AND_TWELVE,
    value: "categoryFive"
  },
  {
    group: categoriesGroups.CATEGORY_SIX_AND_SEVEN,
    value: "categorySix"
  },
  {
    group: categoriesGroups.CATEGORY_SIX_AND_SEVEN,
    value: "categorySeven"
  },
  {
    group: categoriesGroups.CATEGORY_FOUR_AND_NINE,
    value: "categoryNine"
  },
  {
    group: categoriesGroups.CATEGORY_ELEVEN,
    value: "categoryEleven"
  },
  {
    group: categoriesGroups.CATEGORY_FIVE_AND_TWELVE,
    value: "categoryTwelve"
  }
];